import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SalaryService } from 'src/app/Service/Salary/Salary.service';

@Component({
  selector: 'app-SalaryMonthList',
  templateUrl: './SalaryMonthList.component.html',
  styleUrls: ['./SalaryMonthList.component.css']
})
export class SalaryMonthListComponent implements OnInit {
  Filter_title: string = ""
  Filter_year: string = "1405"
  Filter_month: string = "1"
  page: number = 0;
  Procssing: boolean = false
  PdfOpeningPersonId: number | null = null

  modalRef_Delete: any;

  constructor(
    private Salary_Service: SalaryService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private modalService: BsModalService,
    private router: Router
  ) { }


  DataList_Salary: Array<any> = []


  ngOnInit() {
    this.Nav_Service.CheckValidPage(2231).subscribe(
      data => {
        //this.ReadData_Salary()
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Salary() {
    this.Procssing = true
    this.Salary_Service.GetSalaryMonth(Number(this.Filter_year), Number(this.Filter_month)).subscribe(
      data => {
        this.DataList_Salary = data
        this.Procssing = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title() {
    this.page = 0
  }


  //#region Salary Form

  Selected_Salary_Year: number = 0
  Selected_Salary_Month: number = 0
  Selected_Salary_PersonId: number = 0
  Selected_Salary_Person_Fullname: string = ''
  Selected_Salary_Record_Switcher: string = 'List'
  Set_List_Salary_View() {
    //this.ReadData_Salary()
    this.Selected_Salary_Record_Switcher = 'List'
  }

  Set_Form_Salary_View_Add2(PersonId: number) {
    this.Selected_Salary_Year = Number(this.Filter_year)
    this.Selected_Salary_Month = Number(this.Filter_month)
    this.Selected_Salary_PersonId = PersonId
    this.Selected_Salary_Record_Switcher = 'Fish'
  }

  OpenSalaryPdf(PersonId: number) {
    if (this.PdfOpeningPersonId !== null) {
      return;
    }
    this.PdfOpeningPersonId = PersonId;
    const url = this.router.serializeUrl(this.router.createUrlTree(['/SalaryFish'], {
      queryParams: {
        personId: PersonId,
        year: Number(this.Filter_year),
        month: Number(this.Filter_month),
        autoPdf: 1
      }
    }));
    window.open(url, '_blank', 'noopener');
    window.setTimeout(() => this.PdfOpeningPersonId = null, 800);
  }

  //#endregion

}
